<template>
  <div class="content">
    <div class="brand-list">
      <van-radio-group v-model="radio">
        <van-radio :name="item.storeId" v-for="item in storeList" :key="item.storeId" checked-color="#ee0a24"
          @click="handleRadioClick(item.storeId)">
          <template #icon="props">
            <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
          </template>
          <div class="radio-item" style="border-bottom: 1px solid #f5f5f5">
            <img class="store-logo" :src="item.storeLogo" />
            <div class="store-info">
              <div class="store-name">
                {{ item.storeName }}({{ item.shortPlazaName }})
              </div>
              <span :class="['store-role', `role${item.roleType}`]">{{
                roleType[item.roleType]
              }}</span>
            </div>
          </div>
        </van-radio>
      </van-radio-group>
    </div>
    <div v-if="!!storeList.length" class="submit" @click="submit">确定</div>
  </div>
</template>
<script>
// 0-未绑定门店,1-店长,2-区经,3-店员
import { RadioGroup, Radio, Dialog } from 'vant';
import { apiGetStore } from '@/api/insurance';
import { pageTypeConfig } from './hooks';
import * as types from '@/store/mutation-types';
const roleType = {
  0: '未绑定门店',
  1: '店长',
  2: '区经',
  3: '店员',
  4: '财务',
};
const isWechat = () => {
  return (
    String(navigator.userAgent.toLowerCase().match(/MicroMessenger/i)) ===
    'micromessenger'
  );
};
export default {
  name: 'change_store',
  components: {
    vanRadioGroup: RadioGroup,
    vanRadio: Radio,
  },
  computed: {
    userId() {
      return this.$store.state.account.userId;
    },
    pageType() {
      return this.$store.state.base.pageType;
    },
    projectType() {
      return this.$route.query.projectType
    }
  },
  data() {
    return {
      radio: 0,
      storeList: [],
      roleType,
      activeIcon: require('./img/activeIcon.png'),
      inactiveIcon: require('./img/inactiveIcon.png'),
    };
  },

  methods: {
    getStoreList() {
      let { path, caseCode } = pageTypeConfig[this.pageType];

      if (this.projectType != 1) {
        this.$router.replace({
          path,
          query: {
            caseCode,
            projectType: this.projectType
          },
        });
        return
      }
      apiGetStore(this.userId).then((list) => {
        this.storeList = list || [];
        if (!list) {
          if (this.pageType == 'myInsure') {
            // 无店铺 - 本店保险
            Dialog.alert({
              message: '您暂无可选店铺！',
            });
          } else {
            // 无店铺- 公众责任险|财产一切险|工程保险

            this.$store.commit(`account/${types.ACCOUNT_PLAZA_ID}`, '');
            this.$store.commit(`account/${types.ACCOUNT_PLAZA_NAME}`, '');
            this.$store.commit(`account/${types.ACCOUNT_STORE_ID}`, '');
            this.$store.commit(`base/${types.BASE_STORE_NAME}`, '');
            this.$store.commit('base/setBunkDesc', '');

            this.$router.replace({
              path,
              query: {
                caseCode,
                projectType: this.projectType
              },
            });
          }
        }
      });
    },
    handleRadioClick(value) {
      this.radio = value;
    },
    submit() {
      if (!this.radio) return this.$toast('请选择一个店铺');
      let item = this.storeList.find((item) => item.storeId == this.radio);

      this.$store.commit(`account/${types.ACCOUNT_PLAZA_ID}`, item.plazaId);
      this.$store.commit(`account/${types.ACCOUNT_PLAZA_NAME}`, item.plazaName);
      this.$store.commit(`account/${types.ACCOUNT_STORE_ID}`, item.storeId);
      this.$store.commit(`base/${types.BASE_STORE_NAME}`, item.storeName);
      this.$store.commit('base/setBunkDesc', item.bunkDesc);

      let { path, caseCode } = pageTypeConfig[this.pageType];

      this.$router.replace({
        path,
        query: {
          caseCode,
          projectType: this.projectType
        },
      });

      this.$emit('submit');
    },
  },
  mounted() {
    if (isWechat()) {
      this.getStoreList();
    } else {
      let { path, caseCode } = pageTypeConfig[this.pageType];
      this.$router.replace({
        path,
        query: {
          caseCode,
          projectType: this.projectType
        },
      });

    }
  },
};
</script>

<style lang="less" scoped>
.content {
  height: 400px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  position: relative;
  padding-bottom: 14px;

  .brand-list {
    flex: 1;
    line-height: 1;
    padding: 0 16px;
    overflow-y: scroll;
    box-sizing: border-box;

    /deep/.van-radio__label {
      flex: 1;
    }

    /deep/.van-radio__icon {
      font-size: 16px;
    }

    .img-icon {
      width: 16px;
      height: 16px;
    }

    .radio-item {
      display: flex;
      align-items: center;
      padding: 24px 0;

      .store-logo {
        width: 48px;
        height: 48px;
        border-radius: 32px;
      }

      .store-info {
        display: flex;
        flex-direction: column;
        text-align: left;
        margin-left: 8px;

        .store-name {
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
          line-height: 23px;
        }

        .store-role {
          font-size: 12px;
          margin-top: 8px;
          width: 56px;
          height: 18px;
          line-height: 18px;
          border-radius: 9px;
          text-align: center;
          font-weight: 500;
          background: #fdefe4;
          color: #e86f13;
        }

        .role1 {
          background: #fdefe4;
          color: #e86f13;
        }

        .role2 {
          background: #f4edfc;
          color: #9d5de3;
        }

        .role3 {
          background: #e6f2fd;
          color: #208ee7;
        }

        .role4 {
          background: #f4edfc;
          color: #9d5de3;
        }
      }
    }
  }

  .submit {
    // position: fixed;
    // bottom: 40px;
    // left: 15px;
    // right: 15px;
    width: 90%;
    height: 44px;
    line-height: 44px;
    background: linear-gradient(270deg, #ff8366 0%, #ff1d1d 100%);
    border-radius: 22px;
    margin: 0 auto;
    color: #fff;
    font-size: 18px;
  }
}
</style>